import { ContactSortOption } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const contactsQueryAtom = createQueryAtomFactory(
  'trade.contacts',
  (params: {
    accountId?: string;
    searchTerm?: string;
    sorting?: ContactSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    contacts: {
      __args: {
        filter: {
          ...(params.accountId && { accountIds: [params.accountId] }),
          searchTerm: params.searchTerm,
        },
        sorting: params.sorting ?? [],
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      page: {
        offset: true,
        limit: true,
        total: true,
      },
      entries: {
        id: true,
        fullName: true,
        email: true,
        phone: true,
        role: true,
        isPrimary: true,
        account: {
          id: true,
          name: true,
        },
      },
    },
  }),
  {
    select: (data) => ({
      page: data?.contacts.page,
      entries: data?.contacts.entries.map((contact) => ({
        ...contact,
        account: {
          id: contact.account?.id,
          name: contact.account?.name,
        },
      })),
    }),
  },
);
